import React from 'react';
import {
    Card,
    ExamTable,
    MappedExamStatuses,
} from 'components';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { ExamStatus, IExam } from '../../api/ApiClient';
import { IPaginationData } from 'components/Pagination/Pagination';
import { Color, ColorStatus } from '_helpers';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { useLocalErrorHandler } from 'hooks';
import query from '../../helpers/const/query';

const ExamTimeTablesContainer = ({
    setErrorHandler, examsList, onFetchExams, onPush, apiError,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    const [processing, setProcessing] = React.useState(false);

    React.useEffect(() => {
        const fetch = async () => {
            setProcessing(true);
            if (!examsList) {
                onFetchExams({ sortOrder: true });
            } else {
                onFetchExams({
                    sortOrder: true,
                    page: 1,
                    pageSize: 10,
                });
            }
            setProcessing(false);
        };

        fetch();
    }, []);

    const handleChooseExam = (id?: string) => {
        if (!id) return;
        onPush(`/exam/${id}?from=${query.FROM.TIMETABLES}`);
    };

    const handleChangePagination = (newPagination: IPaginationData) => {
        onFetchExams({
            sortOrder: true,
            page: newPagination.page,
            pageSize: newPagination.perPage,
        });
    };

    const statuses = {
        ...MappedExamStatuses,
        [ExamStatus.IsApplying as string]: new ColorStatus(Color.Red, 'Не доступен'),
        [ExamStatus.ApplyingFinished as string]: new ColorStatus(Color.Success, 'Доступен'),
    };

    const getExamData = (exam: IExam) => ({
        ...exam,
        status: statuses[exam.status],
        name: exam.qualificationTitle,
        examType: exam.type,
    });

    const exams = (examsList && examsList.items) || [];
    const tableRows = exams.map(getExamData);

    return (
        <Card
          withoutPadding
          title="Проведение экзаменов"
          category="Список экзаменов, в которых вы подтвердили участие"
          apiError={apiError}
          showLoader={processing}
        >
            <ExamTable
              header={HEADER}
              tableRows={tableRows}
              onChooseExam={handleChooseExam}
              pagination={examsList}
              onChangePagination={handleChangePagination}
              placeholderTitle="Нет экзаменов в списке"
              placeholderText="Здесь будут отображаться все экзамены, в которых вы подтвердили свое участие"
            />
        </Card>
    );
};

const HEADER = [
    'Дата и время',
    'Квалификация',
    'Тип',
    'Статус',
];

const mapState = (state: IRootState) => ({
    examsList: state.exams.examsList,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    onFetchExams: dispatch.exams.fetchExams,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(ExamTimeTablesContainer);

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps;

type RadioOption = 'all' | ExamStatus.ApplyingFinished | ExamStatus.IsApplying;

interface IRadio {
    label: string;
    option: RadioOption;
}
